var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-scrolldown-filled', _vm._b({
    attrs: {
      "verticalWide": ""
    }
  }, 'u-scrolldown-filled', _vm.$attrs, false));

}
var staticRenderFns = []

export { render, staticRenderFns }